/**
 * Charges par défaut (pré-remplies) — le coach peut les modifier dans Paramètres.
 * IDs stables pour référence tests / migrations futures.
 */
export const DEFAULT_COACH_CHARGES_TEMPLATE = [
  { id: "charge-init-urssaf", name: "URSSAF (micro-entreprise)", type: "proportional", percentage: 21.1, category: "tax" },
  { id: "charge-init-rc-pro", name: "Assurance RC Pro", type: "fixed_monthly", amount: 25, category: "insurance" },
  { id: "charge-init-salle", name: "Location salle", type: "fixed_monthly", amount: 120, category: "other" },
  { id: "charge-init-athleos", name: "AthleOS (abonnement)", type: "fixed_monthly", amount: 29, category: "other" },
];

/** @returns {import('../services/chargesCompute').CoachCharge[]} */
export function buildDefaultCoachCharges() {
  return DEFAULT_COACH_CHARGES_TEMPLATE.map((t) => ({
    id: t.id,
    name: t.name,
    type: t.type,
    percentage: t.percentage ?? null,
    amount: t.amount ?? null,
    category: t.category,
    isActive: true,
    notes: "",
  }));
}
